import { RoSchoolCourseEnrollmentStatsEntity } from "../../../../meta-data/app-meta-data.service";

export interface StudentAtRiskInfo extends RoSchoolCourseEnrollmentStatsEntity {
    RiskNumber: number;
    Risk?: RiskLevel;
    RiskClass?: string;
    Tags?: string[];
    Hidden?: boolean;
}

export enum RiskLevel {
    high = 'High',
    medium = 'Medium',
    low = 'Low'
}

